"use client";

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Target } from 'lucide-react';

const attackData = [
  { category: 'SQL Inject', count: 847, color: '#FF3B3B' },
  { category: 'Brute Force', count: 612, color: '#FF6B35' },
  { category: 'XSS', count: 389, color: '#FFB800' },
  { category: 'DDoS', count: 234, color: '#9B59FF' },
  { category: 'Phishing', count: 178, color: '#00A3FF' },
  { category: 'Malware', count: 134, color: '#00E676' },
  { category: 'Recon', count: 91, color: '#6B7A99' },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-[#0F1117] border border-cyber-border rounded-lg p-3 shadow-xl">
        <p className="text-[11px] font-mono font-medium text-cyber-text mb-1">{label}</p>
        <p className="text-[11px] font-mono text-cyber-muted">
          Attempts: <span className="text-white font-medium">{payload[0].value.toLocaleString()}</span>
        </p>
      </div>
    );
  }
  return null;
};

export default function AttackCategoryChart() {
  return (
    <div className="cyber-card p-5 h-full">
      <div className="flex items-center gap-2 mb-4">
        <Target size={15} className="text-cyber-purple" />
        <h3 className="text-sm font-semibold text-white">Attack Categories</h3>
        <span className="text-[10px] font-mono text-cyber-muted ml-auto">24h</span>
      </div>

      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={attackData} layout="vertical" margin={{ top: 0, right: 30, bottom: 0, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1A2035" horizontal={false} />
          <XAxis
            type="number"
            tick={{ fill: '#6B7A99', fontSize: 9, fontFamily: 'IBM Plex Mono' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            type="category"
            dataKey="category"
            tick={{ fill: '#6B7A99', fontSize: 10, fontFamily: 'IBM Plex Mono' }}
            axisLine={false}
            tickLine={false}
            width={65}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="count" radius={[0, 3, 3, 0]}>
            {attackData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} fillOpacity={0.8} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {/* Top Attack Source */}
      <div className="mt-4 pt-4 border-t border-cyber-border">
        <p className="text-[10px] text-cyber-muted font-mono uppercase tracking-widest mb-2">Top Source IPs</p>
        <div className="space-y-1.5">
          {[
            { ip: '103.47.22.91', country: 'CN', count: 312 },
            { ip: '45.142.212.8', country: 'RU', count: 198 },
            { ip: '185.220.101.33', country: 'DE', count: 147 },
          ].map((src) => (
            <div key={src.ip} className="flex items-center gap-2 text-[10px]">
              <span className="font-mono text-cyber-text">{src.ip}</span>
              <span className="text-cyber-muted bg-white/5 rounded px-1 border border-cyber-border">{src.country}</span>
              <span className="ml-auto font-mono text-cyber-red">{src.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}